(function () {
  const videoSection = document.querySelector('.homepage__video');
  const poster = document.querySelector('.homepage__video-poster');
  const video = document.querySelector('.homepage__video-player');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!videoSection || !poster || !video) return;

  function revealPoster() {
    poster.classList.add('is-loaded');
  }

  if (poster.complete) {
    revealPoster();
  } else {
    poster.addEventListener('load', revealPoster);
  }

  function revealVideo() {
    video.classList.add('is-playing');
    videoSection.classList.add('is-video-visible');
  }

  function showControls() {
    videoSection.classList.add('is-video-visible');
  }

  video.addEventListener('playing', revealVideo);

  if (reducedMotionQuery.matches) {
    video.removeAttribute('autoplay');
    video.pause();
    showControls();
  } else {
    const attemptAutoplay = () => {
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(showControls);
      }
    };

    if (video.readyState >= 2) {
      attemptAutoplay();
    } else {
      video.addEventListener('loadeddata', attemptAutoplay, { once: true });
    }

    if (!video.paused && video.readyState >= 2) {
      revealVideo();
    }
  }
})();

(function () {
  const video = document.querySelector('.homepage__video-player');
  const playPauseButton = document.querySelector('[data-homepage-action="play-pause"]');
  const muteButton = document.querySelector('[data-homepage-action="mute"]');

  if (!video || !playPauseButton || !muteButton) return;

  const playIcon = playPauseButton.querySelector('[data-homepage-icon="play"]');
  const pauseIcon = playPauseButton.querySelector('[data-homepage-icon="pause"]');
  const volumeIcon = muteButton.querySelector('[data-homepage-icon="volume"]');
  const volumeMutedIcon = muteButton.querySelector('[data-homepage-icon="volume-muted"]');

  function setIconVisibility(icon, visible) {
    if (!icon) return;
    icon.hidden = !visible;
  }

  function updatePlayPauseState() {
    const isPaused = video.paused;
    setIconVisibility(playIcon, isPaused);
    setIconVisibility(pauseIcon, !isPaused);
    playPauseButton.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
  }

  function updateMuteState() {
    const isMuted = video.muted;
    setIconVisibility(volumeIcon, !isMuted);
    setIconVisibility(volumeMutedIcon, isMuted);
    muteButton.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
  }

  playPauseButton.addEventListener('click', () => {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });

  muteButton.addEventListener('click', () => {
    video.muted = !video.muted;
    updateMuteState();
  });

  video.addEventListener('play', updatePlayPauseState);
  video.addEventListener('pause', updatePlayPauseState);

  updatePlayPauseState();
  updateMuteState();
})();

(function () {
  const background = document.querySelector('.homepage__background');
  const videoSection = document.querySelector('.homepage__video');
  const linksNav = document.querySelector('.homepage__background-links');
  const mobileQuery = window.matchMedia('(max-width: 1019px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!background) return;

  let mobileObserver = null;

  function enableLinks() {
    linksNav?.classList.add('is-interactive');
    linksNav?.removeAttribute('inert');
  }

  function revealBackground() {
    if (background.classList.contains('is-revealed')) return;
    background.classList.add('is-revealed');
    if (reducedMotionQuery.matches) {
      enableLinks();
    }
  }

  function setupMobileReveal() {
    if (!videoSection || !mobileQuery.matches) return;

    mobileObserver?.disconnect();

    mobileObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio <= 0.5) {
            revealBackground();
            mobileObserver?.disconnect();
            mobileObserver = null;
          }
        });
      },
      { threshold: [0, 0.5, 1] }
    );

    mobileObserver.observe(videoSection);
  }

  function initBackgroundReveal() {
    if (mobileQuery.matches) {
      background.classList.remove('is-revealed');
      linksNav?.classList.remove('is-interactive');
      linksNav?.setAttribute('inert', '');
      setupMobileReveal();
      return;
    }

    mobileObserver?.disconnect();
    mobileObserver = null;

    const wasRevealed = background.classList.contains('is-revealed');
    revealBackground();

    if (reducedMotionQuery.matches || wasRevealed) {
      enableLinks();
    }
  }

  if (linksNav && !reducedMotionQuery.matches) {
    linksNav.addEventListener('animationend', (event) => {
      if (event.animationName === 'homepage-background-fade-in' && event.target === linksNav) {
        enableLinks();
      }
    });
  }

  initBackgroundReveal();
  mobileQuery.addEventListener('change', initBackgroundReveal);

  const skipLink = document.querySelector('.homepage__skip-link');

  skipLink?.addEventListener('click', (event) => {
    if (!mobileQuery.matches) return;

    event.preventDefault();
    revealBackground();

    const focusLinks = () => {
      linksNav?.focus();
    };

    if (linksNav?.classList.contains('is-interactive')) {
      focusLinks();
      return;
    }

    linksNav?.addEventListener('animationend', focusLinks, { once: true });
  });
})();

(function () {
  const panel = document.querySelector('.homepage__background-links-panel');
  const circle = document.querySelector('.homepage__background-link-circle');

  if (!panel || !circle) return;

  const links = panel.querySelectorAll('a');

  function moveCircle(x, y) {
    circle.style.left = `${x}px`;
    circle.style.top = `${y}px`;
  }

  function showCircle(x, y) {
    moveCircle(x, y);
    circle.classList.add('is-active');
  }

  function centerCircleOnLink(link) {
    const rect = link.getBoundingClientRect();
    showCircle(rect.left + rect.width / 2, rect.top + rect.height / 2);
  }

  function hideCircle() {
    circle.classList.remove('is-active');
  }

  links.forEach((link) => {
    link.addEventListener('mouseenter', (event) => {
      showCircle(event.clientX, event.clientY);
    });

    link.addEventListener('mousemove', (event) => {
      moveCircle(event.clientX, event.clientY);
    });

    link.addEventListener('mouseleave', () => {
      if (link === document.activeElement && link.matches(':focus-visible')) {
        centerCircleOnLink(link);
        return;
      }

      hideCircle();
    });

    link.addEventListener('focus', () => {
      requestAnimationFrame(() => {
        if (link.matches(':focus-visible')) {
          centerCircleOnLink(link);
        }
      });
    });

    link.addEventListener('blur', () => {
      if (!link.matches(':hover')) {
        hideCircle();
      }
    });
  });
})();
